

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  language: localStorage.getItem('lang') || "zhtw",
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  // 左侧菜单是否显示
  menuShow: false,
  // 钱包信息
  walletInfo: {
    show_address: "",
  },
}
const mutations = {
  // 赋值state
  SET_VALUE(state, data) {
    let {
      key,
      value
    } = data;
    state[key] = value;
  },
}

const actions = {}

const store = new Vuex.Store({
  state,
  mutations,
  actions
})


export default store
